import React, { Component } from "react";
import PropTypes from "prop-types";

class Switch extends Component {
	constructor(props) {
		super(props);

		this.state = {
			label: props.label,
			checked: props.checked
		};

		this.handleChange = this.handleChange.bind(this);
	}

	handleChange() {
		let checked = !this.state.checked;

		this.setState({ checked });

		// OnChange
		this.props.onChange(checked);
	}

	render() {
		const { label, checked } = this.state;
		let dataAction = this.props.hasOwnProperty("data-action")
			? this.props["data-action"]
			: "offers-switch";

		return (
			<div className="switch-component">
				<input
					id="switch-flat"
					className="switch switch--flat"
					type="checkbox"
					checked={checked}
					readOnly={true}
				/>
				<label htmlFor="switch-flat" onClick={this.handleChange} data-action={dataAction} />
				<strong className="switch-label">{label}</strong>
			</div>
		);
	}
}

Switch.propTypes = {
	onChange: PropTypes.func,
	checked: PropTypes.bool
};

Switch.defaultProps = {
	checked: false
};

export default Switch;
